import React from 'react';
import Navbar from './Navbar';
import HeroImg from './HeroImg';
import Info from './Info';
import Work from './Work';
import Timelapse from './Timelapse';
import Footer from './Footer';
import instagramQR from "../../assets/images/canopy_insta_qr_code.png";
import linkedinQR from "../../assets/images/canopy_linkedin_qr_code.png";
import '../../styles/public.css';

const HomePage = () => {
  return (
    <div className="home-page">
      <Navbar />
      <HeroImg />
      <Timelapse />

      {/* QR Codes Section */}
      <section className="home-qr-section">
        <div className="home-qr-container">
          <h2 className="home-qr-title">Connect With Us</h2>
          <p className="home-qr-subtitle">Follow our journey and stay updated with the latest developments</p>
          <div className="home-qr-codes">
            <div className="home-qr-item">
              <img src={instagramQR} alt="Instagram QR Code" className="home-qr-code" />
              <p>Instagram</p>
            </div>
            <div className="home-qr-item">
              <img src={linkedinQR} alt="LinkedIn QR Code" className="home-qr-code" />
              <p>LinkedIn</p>
            </div>
          </div>
        </div>
      </section>

      <Info />
      <Work />
      <Footer />
    </div>
  );
};

export default HomePage;
